import { render, staticRenderFns } from "./ext-multSelect.vue?vue&type=template&id=1b5cad64"
import script from "./ext-multSelect.vue?vue&type=script&lang=js"
export * from "./ext-multSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports